<template>
    <div>
        <Breadcrumbs main="Prescription" title="All Prescription"/>
        <!-- Container-fluid starts-->
        <div class="container-fluid">
            <div class="row">


              <div class="col-md-12">
                <div class="card">
                    <div hidden class="card-header">
                      <h5>Zero Configuration</h5>
                      <span>DataTables has most features enabled by default, so all you need to do to use it with your own tables is to call the construction function:<code>$().DataTable();</code>.</span><span>Searching, ordering and paging goodness will be immediately added to the table, as shown in this example.</span>
                    </div>

                    <div class="card-body">
                      <b-row>
                          <b-col md="4">

                              <b-input-group label-cols="" class="datatable-">
                                  <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
                                  <b-input-group-append>
                                      <b-button id="default-secondary" variant="secondary" :disabled="!filter" @click="filter = ''">Clear</b-button>
                                  </b-input-group-append>
                              </b-input-group>

                          </b-col>

                          <!-- <b-col md="3">
                            <b-form-group hidden label-cols="4" content-cols="6"  label="Selection" class="mb-0 datatable-select">
                                <b-form-select
                                  id="table-select-mode-select"
                                  v-model="selectMode"
                                  :options="modes"
                                  class="mb-3"
                                ></b-form-select>
                              </b-form-group>
                          </b-col> -->

                          <b-col md="4">
                              <b-form-group label-cols="4" content-cols="4" label="Per page" class="mb-0 datatable-select">
                                  <b-form-select style="width:100px" v-model="perPage" :options="pageOptions"></b-form-select>
                              </b-form-group>
                          </b-col>

                          <b-col md="4">
                            <div class="text-right">
                              <div class="form-group mb-0 mr-0"></div>
                              <a class="btn btn-primary mr-3" v-b-modal.prescription >
                                
                                <i class="icon-file"> </i> Add Prescription</a
                              >
                              <!-- <a class="btn btn-outline-primary" v-b-modal.importPatient >
                                <i class="icon-cloud-up"> </i> Import </a
                              > -->
                            </div>

                            <!-- patient form -->
                            <b-modal id="prescription" size="xl" ref="prescriptionModal" v-on:hide="resetPrescription()" :title="`${( editPresciption ? 'Edit Prescription : '+editPresciption : 'Add Prescription ')} `" ok-title="Done" class="theme-modal">

                              <template #modal-header>
                                <h5>{{ editPresciption ? 'Edit Prescription : '+editPresciption : (reviewPresciption ? 'Review Prescription : '+reviewPresciption : 'Add Prescription ') }} <b-button v-if="!(editPresciption || reviewPresciption)" pill size="xs" type="reset" @click="resetPrescription()" variant="outline-danger">Reset</b-button></h5>
                                
                              </template>
                              <!-- {{ patient }} -->
                                <form id="patientForm" @submit.stop.prevent="submitPresciption" class="p-2 px-3">
                                    <h5>Prescription Info</h5>
                                    <div class="row form-group">
                                        <div class="col-12 col-sm-12 col-md-6 col-lg-4 form-group">
                                            <label class="col-form-label" for="recipient-name">Select Patient :
                                                <router-link class="btn pill btn-primary btn-xs" type="reset" target="#" to="/patient/patientlist" >Add</router-link>
                                            </label>
                                            <v-select label="text" :reduce="patientOptions => patientOptions.value" required v-model="pres.patient" :options="patientOptions"></v-select>
                                            <!-- <b-form-select required v-model="pres.patient" :options="patientOptions"></b-form-select> -->
                                        </div>
                                        <div class="col-6 col-sm-6 col-md-6 col-lg-2 form-group">
                                            <label class="col-form-label" for="recipient-name"> Date :</label>
                                            <datepicker input-class="datepicker-here form-control digits" :format="format" :highlighted="{ dates: [ new Date()] }" required v-model="pres.request" placeholder="Requested Date"></datepicker>
                                            <!-- <b-form-input required v-model="pres.request" type="date" placeholder="Requested Date"></b-form-input> -->
                                        </div>
                                        <div class="col-6 col-sm-6 col-md-6 col-lg-2 form-group">
                                            <label class="col-form-label" for="recipient-name"> Status :</label>
                                            <b-form-radio-group required :options="statusOptions" v-model="pres.status" value-field="value" text-field="item">
                                            </b-form-radio-group>
                                        </div>
                                        <!-- <div class="col-6 col-sm-6 col-md-6 col-lg-2 form-group">
                                            <label class="col-form-label" for="recipient-name"> Type :</label>
                                            <b-form-radio-group required :options="typeOptions" v-model="pres.type" value-field="value" text-field="item">
                                            </b-form-radio-group> -->
                                            <!-- <b-form-select required v-model="pres.type" :options="typeOptions"></b-form-select> -->
                                        <!-- </div> -->
                                        <div class="col-6 col-sm-6 col-md-6 col-lg-2 form-group">
                                            <label class="col-form-label" for="recipient-name">Delivery  :</label>
                                            <b-form-radio-group required :options="deliveryOptions" v-model="pres.delivery" value-field="value" text-field="item">
                                            </b-form-radio-group>
                                        </div>

                                        <div class="col-6 col-sm-6 col-md-6 col-lg-2 form-group">
                                            <label class="col-form-label" for="recipient-name">Payment  : </label>
                                            <b-form-radio-group required :options="payOptions" v-model="pres.payment" value-field="value" text-field="item">
                                            </b-form-radio-group>
                                        </div>
                                        <div class="col-6 col-sm-6 col-md-6 col-lg-3 form-group">
                                            <label class="col-form-label" for="recipient-name">Select Insurance :
                                                <router-link class="btn pill btn-primary btn-xs" type="reset" target="#" to="/prescription/insurance" >Add</router-link>
                                            </label>
                                            <v-select label="text" :disabled="(pres.payment == 'Insurance' ? false : true)" :reduce="insuranceOptions => insuranceOptions.value" required v-model="pres.insurance" :options="insuranceOptions"></v-select>

                                            <!-- <b-form-select :disabled="(pres.payment == 'Insurance' ? false : true)" required v-model="pres.insurance" :options="insuranceOptions"></b-form-select> -->
                                        </div>
                                        
                                        <div class="col-6 col-sm-6 col-md-6 col-lg-3 form-group">
                                            <label class="col-form-label" for="recipient-name">Upload Photo:</label>
                                            <b-form-file v-model="pres.upload"  accept=".jpg, .png, .gif" placeholder="Select image  " :state="Boolean(pres.upload)"></b-form-file>
                                        </div>
                                        <div class="col-6 col-sm-6 col-md-6 col-lg-3 form-group">
                                            <label class="col-form-label" for="recipient-name">Select Prescriber :
                                                <router-link class="btn pill btn-primary btn-xs" type="reset" target="#" to="/prescription/prescriber" >Add</router-link>
                                            </label>
                                            <v-select label="text" :reduce="prescriberOptions => prescriberOptions.value" required v-model="pres.prescriber" :options="prescriberOptions"></v-select>
                                        </div>
                                        
                                        <div class="col-6 col-sm-6 col-md-6 col-lg-3 form-group">
                                          <label class="col-form-label" for="recipient-name">Delivery Address :</label>
                                          <b-form-input :disabled="(pres.delivery == 'Delivery' ? false : true)" placeholder="Delivery Address" v-model="pres.deliveryAddress" />
                                        </div>
                                        
                                    </div>
                                    <!-- <b-form-group style="border:0" label="Individual radios" v-slot="{ ariaDescribedby }"> -->
                                    
                                    
                                    <!-- </b-form-group> -->

                                    <hr>

                                    <h5>Medication Info</h5>


                                    <b-row
                                    v-for="(item, index) in pres.medFields"
                                    :id="index"
                                    :key="index"
                                    ref="row"
                                    >

                                    <!-- Item Name -->
                                      <b-col xl="3" lg="4" cols="6">
                                        <b-form-group
                                        label="Drugname"
                                        label-for="item-name"
                                        >
                                        <!-- <b-form-input
                                            size="sm"
                                            id="drugname"
                                            placeholder="Drug name"
                                            list="druglist"
                                        />

                                        <datalist id="druglist">
                                          <option :v-for="text in drugOptions">{{ text }}</option>
                                        </datalist> -->

                                        <v-select 
                                            label="text" 
                                            :reduce="drugOptions => drugOptions.value" 
                                            required 
                                            v-model="item.drugname" 
                                            :options="drugOptions"
                                        ></v-select>

                                        <!-- <b-form-select 
                                            required 
                                            :options="drugOptions" 
                                            v-model="item.drugname"
                                        ></b-form-select> -->

                                        </b-form-group>
                                    </b-col>

                                    <!-- Quantity -->
                                    <b-col xl="2" lg="2" cols="3">
                                        <b-form-group
                                        label="Quantity"
                                        label-for="Quantity"
                                        >
                                        <b-form-input
                                            id="qty"
                                            type="number"
                                            placeholder="Quantity"
                                            v-model="item.qty"
                                        />
                                        </b-form-group>
                                    </b-col>

                                    <!-- dose -->
                                    <b-col xl="2" lg="2" cols="3">
                                        <b-form-group
                                        label="Dose"
                                        label-for="Dose"
                                        >
                                        <b-form-input
                                            @input="getQty(item)"
                                            id="dose"
                                            type="number"
                                            placeholder="Dose"
                                            v-model="item.dose"
                                        />
                                        </b-form-group>
                                    </b-col>

                                    <!-- dosage -->
                                    <b-col
                                        xl="3"
                                        lg="4"
                                        cols="6"
                                    >
                                    
                                        <b-form-group
                                        label="Select Dosage"
                                        label-for="dosage"
                                        >

                                        <v-select 
                                            label="text" 
                                            :reduce="dosageOptions => dosageOptions.value" 
                                            required 
                                            @input="getQty(item)"
                                            v-model="item.dosage" 
                                            :options="dosageOptions"
                                        ></v-select>
                                        
                                        <!-- <b-form-select 
                                            required 
                                            :options="dosageOptions" 
                                            v-model="item.dosage"
                                        ></b-form-select> -->

                                        
                                        <!-- <label class="col-form-label" for="recipient-name">Meal : </label> -->
                                        <!-- <b-form-radio-group size="sm" required :options="mealOptions" v-model="item.meal" value-field="value" text-field="item">
                                        </b-form-radio-group> -->
                                        </b-form-group>
                                    </b-col>

                                    <b-col
                                        xl="2"
                                        lg="2"
                                        cols="6"
                                    >

                                    <b-form-group
                                        label="Select Meal"
                                        label-for="dosage"
                                        >
                                        <!-- <b-form-select 
                                            :options="mealOptions" 
                                            v-model="item.meal"
                                        ></b-form-select> -->

                                        <v-select 
                                            label="text" 
                                            :reduce="mealOptions => mealOptions.value" 
                                            v-model="item.meal" 
                                            :options="mealOptions"
                                        ></v-select>

                                    </b-form-group>

                                    </b-col>

                                    <!-- refills -->
                                    <b-col xl="2" lg="" cols="4">
                                        <b-form-group
                                        label="Refill Date"
                                        label-for="quantity"
                                        >
                                        <!-- <b-form-input
                                            id="refills"
                                            placeholder="No "
                                            v-model="item.refills"
                                        /> -->

                                        <datepicker input-class="datepicker-here form-control digits" :format="format"  v-model="item.refills" placeholder="Refill Date" :highlighted="{ dates: [ new Date()] }"></datepicker>
                                        </b-form-group>
                                    </b-col>

                                    <!-- date -->
                                    <b-col
                                        xl="2"
                                        lg=""
                                        cols="4"
                                    >
                                        <b-form-group
                                        label="Start Date"
                                        label-for="sdate"
                                        >
                                        <datepicker input-class="datepicker-here form-control digits" :format="format"  v-model="item.sdate" placeholder="Start Date" :highlighted="{ dates: [ new Date()] }" @input="getQty(item)"></datepicker>
                                        <!-- <b-form-input
                                            id="date"
                                            type="date"
                                            v-model="item.sdate"
                                        /> -->
                                        </b-form-group>
                                        <!-- <span v-if="(item.sdate !== '')" class="btn btn-outline-primary btn-xs">{{ item.sdate }}</span> -->
                                    </b-col>
                                    <b-col
                                        xl="2"
                                        lg=""
                                        cols="4"
                                    >
                                        <b-form-group
                                        label="End Date"
                                        label-for="edate"
                                        >
                                        <datepicker input-class="datepicker-here form-control digits" :format="format"  v-model="item.edate" placeholder="End Date" :highlighted="{ dates: [ new Date()] }" @input="getQty(item)"></datepicker>
                                        <!-- <b-form-input
                                            id="date"
                                            type="date"
                                            v-model="item.edate"
                                        /> -->
                                        </b-form-group>
                                        <!-- <span v-if="(item.edate !== '')" class="btn btn-outline-primary btn-xs">{{ item.edate }}</span> -->
                                    </b-col>

                                    <!-- remarks -->
                                    <b-col xl="4" lg="3" cols="8">
                                        <b-form-group
                                        label="Remarks"
                                        label-for="remarks"
                                        >
                                        <b-form-input
                                            id="remarks"
                                            placeholder="Enter remarks "
                                            v-model="item.remarks"
                                        />
                                        </b-form-group>
                                    </b-col>

                                    <!-- Remove Button -->
                                    <b-col
                                        xl="2"
                                        lg="2"
                                        cols="4"
                                        class="mt-2"
                                    >
                                        <b-button
                                        variant="outline-danger"
                                        class="mt-0 mt-3 px-2"
                                        block
                                        @click="removeMedField(index)"
                                        >
                                        <i class="icon-trash mr-1"> </i>
                                        <!-- <span> Delete</span> -->
                                        </b-button>
                                    </b-col>
                                    <b-col cols="12">
                                        <hr>
                                    </b-col>
                                    
                                    </b-row>

                                    <div class="text-center">
                                      <b-button
                                      class="py-1 px-5 text-center"
                                      variant="outline-primary"
                                      @click="addMedField"
                                      >
                                      <i class="icon-plus mr-1"> </i>
                                      <span>Add New</span>
                                      </b-button>
                                    </div>
                                
                                

                                    <br>
                                    <br>

                                    <div class="row">
                                        <div class="col-lg-4 col-sm-12 col-md-6 col-lg-4 ">
                                            <b-button block  type="submit" variant="primary">Submit</b-button>
                                        </div>
                                    </div>

                                    <!-- <label class="col-form-label" for="message-text">Message:</label>
                                    <b-form-textarea
                                      id="textarea"
                                      rows="3"
                                    ></b-form-textarea> -->
                                </form>
                            </b-modal>

                            <!-- import patient -->
                            <b-modal id="viewPrescription" ref="viewPrescription" size="xl" title="Prescription" class="theme-modal">
                              <!-- <h5>Basic Info </h5> -->
                              <div class="px-3 py-1">
                                <div class="row">
                                  <div class="col-sm-6">
                                    <div class="media">
                                      <div class="media-body m-l-20">
                                        <!-- <h4 class="media-heading">Cuba</h4> -->
                                        <a @click="status()"  :class="`btn ${ (['Dispensed'].includes(viewPres.status) ? 'btn-primary' : (viewPres.status ==  'Active' ? 'btn-info' : (viewPres.status == 'Completed' ? 'btn-success' : 'btn-warning text-dark')))} btn-sm btn-pill mr-3`">
                                            {{ viewPres.status }}
                                          </a>
                                        <p>
                                          <!-- hello@cuba.in -->
                                          <!-- <br /> -->
                                          Dispensed by: 
                                          <span class="digits txt-primary">{{ viewPres.dispensedBy }} </span>
                                        </p>
                                      </div>
                                    </div>
                                    <!-- End Info-->
                                  </div>
                                  <div class="col-sm-6">
                                    <div class="text-md-right">
                                      <h3>
                                         
                                        <span class="digits counter pr-3">#P{{ viewPres.prescriptionID.split('-')[0] }}</span>
                                        <button v-if="(viewPres.review)" v-b-tooltip.hover class="btn btn-pill btn-sm btn-primary" :title="`#P${viewPres.review.split('-')[0] }`">  review </button>
                                      </h3>
                                      <p>
                                        
                                        Requested Date: 
                                        <span class="digits txt-primary"><b>{{ new Date(viewPres.date).toDateString().substr(4) }}</b></span>
                                        <br />Created by:
                                        <span class="digits txt-primary">{{ viewPres.user }}</span>
                                      </p>
                                    </div>
                                    <!-- End Title-->
                                  </div>
                                </div>
                              </div>
                              <hr/>
                              
                              <div class="px-4 pb-5 px-1">
                                <p class="mb-1 txt-primary"> Prescription Info </p><br>
                                <b-row>

                                  <b-col sm="6" md="3">
                                    <h6>Patient Name: </h6>
                                    <span class="digits">{{ viewPres.patient }}</span>
                                  </b-col>

                                  <b-col sm="6" md="3">
                                    <h6>Prescriber : </h6>
                                    <span class="txt-primary">{{ viewPres.prescriber }} </span>
                                  </b-col>

                                  <b-col sm="6" md="3">
                                    <h6>Delivery :</h6>
                                    <span v-if="viewPres.delivery == 'Pickup'" class="digits">{{ viewPres.delivery }} </span>
                                    <span v-if="viewPres.delivery == 'Delivery'" class="txt-"> {{  "("+ viewPres.deliveryAddress +")" }}</span>
                                  </b-col>

                                  <b-col sm="6" md="3">
                                    <h6>Payment: {{ ((viewPres.payment == 'Insurance') ? '('+viewPres.payment+')' : '') }} </h6>
                                    <span v-if="viewPres.payment =='Cash'" class="txt-primary">{{ viewPres.payment }} </span>
                                    <span v-if="viewPres.payment == 'Insurance'" class="txt-primary">{{ viewPres.insurance }}</span>
                                  </b-col>

                                </b-row>

                              </div>

                              
                              <div class="px-4 pb-2 py-1">
                                <p class="mb-1 txt-primary"> Medication Info </p><br>
                                <b-table
                                  ref="table"
                                  :items="viewPres.medications"
                                  :fields="presfields"
                                >

                                <template #cell(drugname)="row">
                                  {{ row.item.drugname+' ('+row.item.qty+')' }}
                                </template>

                                <template #cell(dosage)="row">
                                  {{ row.item.dose+' '+dosing[row.item.dosage]+' ('+mealing[row.item.meal]+')' }}
                                </template>

                                <template #cell(duration)="row">
                                  {{  (row.item.sdate == "" || row.item.edate == "") ? "" : new Date(row.item.sdate).toDateString().substr(4)+' — '+new Date(row.item.edate).toDateString().substr(4) }}
                                </template>

                                <template #cell(refills)="row">
                                  {{ row.item.refills }}
                                </template>

                                <template #cell(action)="row">
                                  <b-button variant="primary" @click="viewmed(row.item)" class="px-3 mr-2" size="sm"> <i class="icon-eye"> </i>  </b-button>
                                </template>

                                </b-table>

                              </div>

                              <div class="p-4">
                                <p class="mb-1 txt-primary"> Uploaded Image </p><br>
                                <img style="width:480px" :src="'http://localhost:4000/api/prescription/files/'+$store.state.authentication.user.token+'/'+viewPres.upload">
                              </div>

                            </b-modal>

                            <!-- add comment -->
                            <b-modal id="addComment" ref="addCommentModal" :title="`Add Comment : ${comment.name}`" ok-title="Ok" class="theme-modal">

                              <template #modal-header>
                                <h5>{{ comment.editComment ? 'Edit Comment : '+comment.editComment : 'Add Comment : '+comment.name }} </h5>
                                
                              </template>

                              <form id="commentForm" @submit.stop.prevent="submitComment" class="p-2 px-3">
                                  
                                  <label class="col-form-label" type="text" for="recipient-name">Title:</label>
                                  <b-form-input required v-model="comment.title" placeholder="title"></b-form-input>

                                  <label class="col-form-label" for="">Comment</label>
                                  <b-form-textarea
                                    id="textarea"
                                    v-model="comment.body"
                                    placeholder="Enter comment..."
                                    rows="3"
                                    max-rows="6"
                                  ></b-form-textarea>
                                    <br>
                                  <b-button block  type="submit" variant="primary">Submit</b-button>
                              </form>
                            </b-modal>

                            <b-modal id="viewComment" size="lg" ref="viewCommentModal" :title="'View Comment : '+comment.name" ok-title="Ok" class="theme-modal">
                              <b-table
                                show-empty
                                ref="Table"
                                :items="comments"
                                :fields="commentfields"
                                :filter="filter"
                                :current-page="currentPage"
                                :per-page="perPage"
                                @filtered="onFiltered"
                                @row-selected="onRowSelected"
                              >
                                <template #cell(body)="row">
                                    <u class="txt-primary"> {{ row.item.title }} </u>
                                    <p> {{ row.item.body }} </p>
                                </template>
                                

                                <template #cell(date)="row">
                                      {{ new Date(row.item.createdAt).toDateString().substr(4) }}
                                </template>

                                <template #cell(action)="row">

                                  <b-button variant="primary" @click="editcomment(row.item)" class="px-3 mr-2" size="sm"> <i class="icon-pencil"> </i>  </b-button>
                                  <b-button variant="danger" @click="delcomment(row.item)" class="px-3" size="sm"> <i class="icon-trash"> </i> </b-button>

                                </template>
                              </b-table>
                            </b-modal>
                          </b-col>
                      </b-row>

                           <b-modal id="viewMed" size="lg" ref="viewMedModal" :title="'View Medication : '+med.name" ok-title="Ok" class="theme-modal">
                              <b-table
                                show-empty
                                ref="Table3"
                                :items="meds"
                                :fields="medFields"
                                :filter="filter"
                                :current-page="currentPage"
                              >
                                <template #cell(body)="row">
                                    <u class="txt-primary"> {{ row.item.title }} </u>
                                    <p> {{ row.item.body }} </p>
                                </template>
                                

                                
                                <template #cell(due)="row">
                                    <a @click="due(row.item)" :class="`btn ${ (row.item.due == true ? 'btn-primary' : 'btn-warning text-dark')} btn-xs btn-pill mr-3`">
                                      {{ (row.item.due == true ? 'Yes' : 'Not Yet') }}
                                    </a>
                                </template>

                                <template #cell(status)="row">
                                    <a @click="checkMed(row.item)" :class="`btn ${ (row.item.status == 'Taken' ? 'btn-primary' : 'btn-warning text-dark')} btn-xs btn-pill mr-3`">
                                      {{ (row.item.status) }}
                                    </a>
                                </template>
                          
                              <template #cell(dosage)="row">
                                <span> {{ row.item.dosage.split('(')[0] }}</span>
                                <i class="txt-primary">{{ row.item.dosage.split('(')[1].split(')')[0] }}</i>
                              </template>
                              
                              <template #cell(dateTaken)="row">
                                <span v-if="(row.item.dateTaken)">

                                  {{ new Date(row.item.dateTaken).toUTCString().substr(4,12)+', ' }}

                                  <span class="txt-primary">{{ formatAMPMString((row.item.dateTaken).substr(11, 8)) }}</span>
                                </span>
                                
                                
                              </template>

                              <template #cell(date)="row">
                                {{ new Date(row.item.date).toUTCString().substr(4,12)+', ' }}
                                
                                <span class="txt-primary">{{ formatAMPMString((row.item.date).substr(11, 8)) }}</span>
                              </template>

                                <template #cell(action)="row">

                                  <b-button variant="primary" @click="checkMed(row.item)" class="px-3 mr-2" size="sm"> <i :class="(row.item.status == 'Taken' ? 'icon-check' : 'icon-close')"> </i>  </b-button>
                                  <!-- <b-button variant="danger" @click="delcomment(row.item)" class="px-3" size="sm"> <i class="icon-trash"> </i> </b-button> -->

                                </template>
                              </b-table>
                            </b-modal>

                            <b-modal id="addDate" size="sm" ref="addDateModal" :title="'Add Date : '+med.datetime" ok-title="Ok" class="theme-modal">

                              <form @submit.stop.prevent="medDateTime">

                                 <label class="col-form-label" type="text" for="recipient-name">Date:</label>
                                  <b-form-input required type="date" v-model="med.date" placeholder="title"></b-form-input>

                                   <label class="col-form-label" type="text" for="recipient-name">Time:</label>
                                  <b-form-input required type="time" v-model="med.time" placeholder="title"></b-form-input>
                                  <br>
                                    <div class="row">
                                        <div class="col-12 ">
                                            <b-button block  type="submit" variant="primary">Submit</b-button>
                                        </div>
                                    </div>
                              </form>
                            </b-modal>

                    <!-- {{ selected }} -->
                      <div class="table-responsive datatable-vue">
                        <b-table
                          show-empty
                          ref="selectableTable"
                          :items="items"
                          :fields="tablefields"
                          :sort-by.sync="sortBy"
                          :filter="filter"
                          :sort-desc="true"
                          :current-page="currentPage"
                          :per-page="perPage"
                          @filtered="onFiltered"
                          @row-selected="onRowSelected"
                        >
                          <template #cell(action)="row">
                            <!-- <b-button size="sm" @click="row.toggleDetails" class="mr-2 ">
                              {{ row.detailsShowing ? 'Hide' : 'Show'}} Details
                            </b-button> -->
                            <b-dropdown text="more" size="sm" left class="mx-2" menu-class="dropdown-content" variant="primary">
                              <b-dropdown-item v-if="(['Active', 'Completed'].includes(row.item.status) )" @click="review(row.item)">Review</b-dropdown-item>
                              <b-dropdown-item v-if="(['Pending', 'Dispensed'].includes(row.item.status))" @click="edit(row.item)">Edit</b-dropdown-item>
                              <b-dropdown-item @click="view(row.item)">View </b-dropdown-item>
                              <b-dropdown-item @click="addcomment(row.item)">Add comment</b-dropdown-item>
                              <b-dropdown-item @click="viewcomment(row.item.prescriptionID)">View comment</b-dropdown-item>
                              <b-dropdown-divider></b-dropdown-divider>
                              <b-dropdown-item @click="del(row.item)">Delete</b-dropdown-item>
                          </b-dropdown>
                          </template>

                          <template #cell(prescriptionID)="row">
                               <a href="#" @click="view(row.item)"> #P{{ row.item.prescriptionID.split('-')[0] }} </a>

                               <button v-if="(row.item.review)" @click="view(filterItems(row.item.review))" v-b-tooltip.hover class="btn btn-pill btn-xs btn-primary" :title="`#P${row.item.review.split('-')[0] }`">  review </button>
                          </template>

                          <template #cell(status)="row">
                              <a @click="status(row.item)" :class="`btn ${ (['Dispensed'].includes(row.item.status) ? 'btn-primary' : (row.item.status ==  'Active' ? 'btn-info' : (row.item.status == 'Completed' ? 'btn-success' : 'btn-warning text-dark')))} btn-xs btn-pill mr-3`">
                                {{ row.item.status }}
                              </a>
                          </template>

                          <template #cell(payment)="row">
                            <span v-b-tooltip.hover class="txt-primary" :title="row.item.insurance"> <u>{{ row.item.payment }}</u> </span>
                          </template>

                          <template #cell(delivery)="row">
                            <span v-if="row.item.delivery == 'Delivery'" v-b-tooltip.hover class="txt-primary" :title="row.item.deliveryAddress"> {{ row.item.delivery }} </span>
                            <span v-else> {{ row.item.delivery }} </span>
                          </template>

                          <template #cell(prescriber)="row">
                            <span class="txt-primary"> {{ row.item.prescriber }} </span>
                            <!-- <span :class="`digits btn ${ (row.item.type == 'One time') ? 'btn-primary' : 'btn-warning text-dark' } btn-xs btn-pill`">{{ row.item.type }}</span> -->
                          </template>

                          <template #cell(date)="row">
                                {{ new Date(row.item.date).toDateString().substr(4) }}
                          </template>
                        </b-table>
                        
                      </div>

                      <p>{{ items.length }} items </p>

                      <b-col md="6" class="my-1">
                        <b-pagination
                          v-model="currentPage"
                          :total-rows="totalRows.length"
                          :per-page="perPage"
                          class="my-0"
                        ></b-pagination>
                      </b-col>
                      


                    </div>

                </div>
              </div>

            </div>
        </div>
        <!-- Container-fluid Ends-->
    </div>
</template>

<script>
// import vue2Dropzone from 'vue2-dropzone'
// import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import axios from 'axios'

import Datepicker from 'vuejs-datepicker';
import moment from 'moment'

export default {
  data(){
    return{
      format: "yyyy-MM-dd",
      singledropzoneOptions:{
          url:"http://localhost:8080",
          thumbnailWidth: 150,
          maxFiles:1,
          maxFilesize: 0.7,
          addRemoveLinks: true,
          dictDefaultMessage:"<i class='icon-cloud-up'></i><h6>Drop file here or click to upload.</h6><span>( Selected file is <strong>uploaded</strong> imediately after selection.)</span>"
      },
      editPresciption: false,
      reviewPresciption: false,
      pres: {
        prescriptionID: '',
        patient: '',
        request: '',
        payment: '',
        insurance: '',
        prescriber: '',
        delivery: '',
        deliveryAddress: '',
        status: '',
        upload: null,
        type: '',
        medFields: [
            { 
                drugname: '', 
                qty: '',
                dose: '',
                refills: '',
                dosage: '',
                meal: '',
                remarks: '',
                sdate: '',
                edate: '' 
            }
        ],
      },
      viewPres: {
        prescriptionID: 'f9f90a17-fac7-426e-9a56-4a935c1621c5',
        patient: 'Yaw Barima',
        delivery: 'Pickup',
        deliveryAddress: 'Kotobabi',
        status: 'Dispensed',
        insurance: 'SIC Insurance',
        payment: 'insurance',
        type: 'One time',
        review: '',
        medications: [
        { drugname:"Paracetamol tabs 500mg (20)", dose:'1', dosage:" x 2 times daily", meal: "with meal", duration:"12 Jan 2012 — 12 Feb 2012", refills:"" },
        { drugname:"Ibprufen tabs 400mg (30)", dose:'1', dosage:" x 3 times daily", meal: "after meal", duration:"22 Apr 2012 — 29 Apr 2012", refills:"2" },
        ],
        dispensedBy: 'Ama Pomaa',
        date: '29 Apr 2022',
        user: 'kofi Nti'
      },
      comment: {
        editComment: false,
        title: '',
        body: '',
        name:'',
        prescriptionID: '',
        id: ''
      },
      patientOptions: [
        ],
      insuranceOptions:[
      ],
      prescriberOptions: [

      ],
      drugOptions:[
      ],
      payOptions: [
        { value:'Cash', item: 'Cash' },
        { value:'Insurance', item: 'Insurance' }
      ],
      deliveryOptions:[
        { value:'Delivery', item: 'Delivery' },
        { value:'Pickup', item: 'Pickup' }
      ],
      statusOptions:[
        { value:'Dispensed', item: 'Dispensed' },
        { value:'Pending', item: 'Pending' }
      ],
      typeOptions: [
        // { value: '', item: 'Select type' },
        { value:'One time', item: 'One time' },
        { value:'Refill', item: 'Refill' }
      ],
      dosing: {'1': ' daily' ,'2': ' x 2 times daily' ,'3': ' x 3 times daily' ,'4': ' x 4 times daily' ,'5': ' at night daily' ,'6': ' in the morning daily' ,'7': ' weekly' ,'8': ' x 2 weekly' ,'9': ' x 3 weekly' ,'10': ' x 4 weekly' ,'11': ' at night weekly' ,'12': ' in the morning weekly' },
      dosageOptions: [
          { value: '', text: 'Select Dosage' },
          { value:'1', text: ' daily' },
          { value:'2', text: ' x 2 times daily' },
          { value:'3', text: ' x 3 times daily' },
          { value:'4', text: ' x 4 times daily' },
          { value:'5', text: ' at night daily' },
          { value:'6', text: ' in the morning daily' },
          { value:'7', text: ' weekly' },
          { value:'8', text: ' x 2 weekly' },
          { value:'9', text: ' x 3 weekly' },
          { value:'10', text: ' x 4 weekly' },
          { value:'11', text: ' at night weekly' },
          { value:'12', text: ' in the morning weekly' },
        ],
      mealing: {'before': 'Before meals', 'with': 'With meals', 'after': 'After meals' },
      mealOptions: [
        { value: '', text: 'Select meal' },
        { value:'before', text: 'Before meals' },
        { value:'with', text: 'With meals' },
        { value:'after', text: 'After meals' }
      ],
      tablefields: [
        { key: 'prescriptionID', label: 'ID.', sortable: true, },
        { key: 'date', label: ' Date', sortable: true, },
        { key: 'status', label: 'Status', sortable: true, },
        { key: 'patient', label: 'Patient', sortable: true, },
        { key: 'prescriber', label: 'Prescriber', sortable: true, },
        { key: 'delivery', label: 'Delivery', sortable: true, },
        { key: 'payment', label: 'Payment', sortable: true, },
        { key: 'action', label: 'action', sortable: false, },
      ],
      items: [
      ],
      presfields: [
        { key: 'drugname', label: 'Drugname (Qty)', },
        { key: 'dosage', label: 'Dosage',  },
        { key: 'duration', label: 'Duration', },
        { key: 'refills', label: 'Refills', },
        { key: 'remarks', label: 'Remarks', },
        { key: 'action', label: 'Action', },
      ],
      commentfields: [
        { key: 'body', label: 'Title & Comment', sortable: true, },
        { key: 'date', label: 'Date', sortable: true, },
        { key: 'action', label: 'Action', sortable: false, },
      ],
      comments: [],
      presItems: [
        { drugname:"Paracetamol tabs 500mg (20)", dose:'1', dosage:" x 2 times daily", meal: "with meal", duration:"12 Jan 2012 — 12 Feb 2012", refills:"" },
        { drugname:"Ibprufen tabs 400mg (30)", dose:'1', dosage:" x 3 times daily", meal: "after meal", duration:"22 Apr 2012 — 29 Apr 2012", refills:"2" },
      ],
      med: {
        name: '',
        datetime: '',
        id: '',
        date: '',
        time: ''
      },
      meds: [],
      medFields: [
        { key: 'date', label: 'Date', sortable: true, },
        { key: 'dosage', label: 'Dosage', sortable: true, },
        { key: 'status', label: 'Status', sortable: true, },
        { key: 'dateTaken', label: 'Date Taken', sortable: true, },
        { key: 'action', label: 'Action', sortable: false, },
      ],
      modes: ['multi', 'single', 'range'],
      filter: null,
      selectMode: 'multi',
      selected: [],
      sortBy: 'date',
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [5, 10, 15, 25, 50, 100],
    }
  },
  components: {
    Datepicker
    // vueDropzone: vue2Dropzone
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.tablefields
        .filter(f => f.sortable)
        .map(f => {
          return { text: f.label, value: f.key }
        })
    }
  },
  created() {
    // watch and fetch
    this.$watch(
      () => this.$route.$params,
      () => {
        this.fetchData()
        // get
        this.getPatient()
        this.getDrug()
        this.getInsurance()
        this.getPrescriber()
      },
      { immediate: true }

    )

  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.items.length
  },
  methods: {
    fetchData() {

      //
      axios.get('/prescription')
        .then(response=>{
          //
          this.items = response.data
        })
        .catch( e => {
          this.$swal({
            title:"Failed!",
            text: e.response.data,
            type:'error'
          });
        })

    },
    addMedField() {
        this.pres.medFields.push(
            { 
                drugname: '', 
                qty: '',
                dose: '',
                refills: '',
                dosage: '',
                meal: '',
                remarks: '',
                sdate: '',
                edate: '' 
            }
        )
    },
    removeMedField(index)  {
        this.pres.medFields.splice(index, 1)
    },
    resetPrescription() {
      this.editPresciption = false
      this.pres.patient = ''
      this.pres.request = ''
      this.pres.payment = ''
      this.pres.insurance = ''
      this.pres.delivery = ''
      this.pres.deliveryAddress = '',
      this.pres.prescriber = ''
      this.pres.status = '',
      this.pres.upload = null,
      this.pres.type = '',
      this.pres.medFields = [{ 
                                drugname: '', 
                                qty: '',
                                dose: '',
                                refills: '',
                                dosage: '',
                                meal: '',
                                remarks: '',
                                sdate: '',
                                edate: '' 
                            }]
    },
    resetComment() {
      this.comment.editComment = false
      this.comment.prescriptionID = ''
      this.comment.name = ''
      this.comment.title = ''
      this.comment.body = ''
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    onRowSelected(items) {
      this.selected = items
    },
    selectAllRows() {
      this.$refs.selectableTable.selectAllRows()
    },
    clearSelected() {
      this.$refs.selectableTable.clearSelected()
    },
    sendingEvent (file, xhr, formData) {
        formData.append('paramName', 'some value or other');
    },
    submitPresciption(){

      let url
      let method

      if (this.editPresciption) {
        url = '/prescription/'+this.pres.prescriptionID.split('-')[0]
        method = axios.patch;
      } else if (this.reviewPresciption) {
        url = '/prescription/review/'+this.pres.prescriptionID.split('-')[0]
        method = axios.post;
      }
      else {
        url = '/prescription'
        method = axios.post;
      }

      const formData = new FormData();

      formData.append('prescriptionID', ((this.editPresciption || this.reviewPresciption) ? this.pres.prescriptionID : ''))
      formData.append('patient', this.pres.patient)
      formData.append('request', this.pres.request)
      formData.append('payment', this.pres.payment)
      formData.append('insurance', this.pres.insurance)
      formData.append('delivery', this.pres.delivery)
      formData.append('deliveryAddress', this.pres.deliveryAddress)
      formData.append('prescriber', this.pres.prescriber)
      formData.append('status', this.pres.status)
      formData.append('type', this.pres.type)
      formData.append('meds', JSON.stringify(this.pres.medFields))
      formData.append('file', this.pres.upload)

      method(url, formData)
      .then(response=>{
        //
        this.$swal({
          title:"Good job!",
          text: response.data,
          type:'success'
        });

        //
        this.fetchData()

        this.$refs.prescriptionModal.hide()

      })
      .catch( e => {
        this.$swal({
          title:"Failed!",
          text: e.response.data,
          type:'error'
        });
      })

      
    },
    review(data) {
      // modal
      this.$refs.prescriptionModal.show()
      this.reviewPresciption = '#PR'+data.prescriptionID.split('-')[0]
      // form
      this.pres.prescriptionID = data.prescriptionID
      this.pres.patient = data.patient
      this.pres.request = data.date.substring(0,10)
      this.pres.insurance = data.insurance
      this.pres.delivery = data.delivery
      this.pres.deliveryAddress = data.deliveryAddress
      this.pres.prescriber = data.prescriber
      this.pres.status = data.status
      this.pres.payment = data.payment
      this.pres.type = data.type
      this.pres.medFields = data.medications
      this.pres.upload = data.upload
    },
    edit(data) {
      // modal
      this.$refs.prescriptionModal.show()
      this.editPresciption = '#PR'+data.prescriptionID.split('-')[0]
      // form
      this.pres.prescriptionID = data.prescriptionID
      this.pres.patient = data.patient
      this.pres.request = data.date.substring(0,10)
      this.pres.insurance = data.insurance
      this.pres.delivery = data.delivery
      this.pres.deliveryAddress = data.deliveryAddress
      this.pres.prescriber = data.prescriber
      this.pres.status = data.status
      this.pres.payment = data.payment
      this.pres.type = data.type
      this.pres.medFields = data.medications
    },
    view(data){
      // modal
      this.$refs.viewPrescription.show()
      this.viewPres = data
      //

    },
    filterItems(review){

      const item = this.items.find( (data) => ( data.prescriptionID.includes(review) ) )
      console.log(item)
      return item
    },
    del(data){

      this.$swal({
				text:`Are you sure you want to delete '${'#PR'+data.prescriptionID.split('-')[0]}'?`,
				showCancelButton: true,
				confirmButtonText: 'Yes',
        type:'error'
			}).then((result)=>{

        if(result.value){

          axios.delete('/prescription/'+data.prescriptionID, { prescriptionID: data.prescriptionID })
            .then(response=>{
              //
              this.$swal({
                title:"Good job!",
                text: response.data,
                type:'success'
              });
              //
              this.fetchData()
            })
            .catch( e => {
              this.$swal({
                title:"Failed!",
                text: e.response.data,
                type:'error'
              });
          })
        }
      })
    },
    status(data) {
      //

      if (!['Pending', 'Dispensed'].includes(data.status)) {
        //
        return 
      }
      
      axios.post('/prescription/status', { prescriptionID: data.prescriptionID, status: data.status })
      .then(response=>{
        //
        this.$swal({
          title:"Success!",
          text: response.data,
          type:'success'
        });
        //
        this.fetchData()
      })
      .catch( e => {
        this.$swal({
          title:"Failed!",
          text: e.response.data,
          type:'error'
        });
      })

    },
    getPatient() {
      //
      axios.get('/patient/active')
      .then(response=>{
        //
        let data = [{ value: '', text: 'Select Patient' }]
        for (let index = 0; index < response.data.length; index++) {
          //
          const element = { value: response.data[index]['fullname'], text: response.data[index]['fullname']+' '+response.data[index]['tel'] };
          data.push(element)
        }
        this.patientOptions = data
      })
      .catch( e => {
        this.$swal({
          title:"Failed!",
          text: e.response.data,
          type:'error'
        });
      })

    },
    getDrug() {
      //
      axios.get('/drug')
      .then(response=>{
        //
        let data = [{ value: '', text: 'Select Drug' }]
        for (let index = 0; index < response.data.length; index++) {
          //
          const element = { value: response.data[index]['drugname']+' '+response.data[index]['form']+' '+response.data[index]['strength'], text: response.data[index]['drugname']+' '+response.data[index]['form']+' '+response.data[index]['strength'] };
          data.push(element)
        }
        this.drugOptions = data
      })
      .catch( e => {
        this.$swal({
          title:"Failed!",
          text:"You clicked the button!"+e,
          type:'error'
        });
      })
    },
    getInsurance() {
      //
      axios.get('/insurance')
      .then(response=>{
        //
        let data = [{ value: '', text: 'Select Insurance' }]
        for (let index = 0; index < response.data.length; index++) {
          //
          const element = { value: response.data[index]['name'], text: response.data[index]['name'] };
          data.push(element)
        }
        this.insuranceOptions = data
      })
      .catch( e => {
        this.$swal({
          title:"Failed!",
          text: e.response.data,
          type:'error'
        });
      })
    },
    getPrescriber() {
      //
      axios.get('/prescriber')
      .then(response=>{
        //
        let data = [{ value: '', text: 'Select Prescriber' }]
        for (let index = 0; index < response.data.length; index++) {
          //
          const element = { value: response.data[index]['name'], text: response.data[index]['name'] };
          data.push(element)
        }
        this.prescriberOptions = data
      })
      .catch( e => {
        this.$swal({
          title:"Failed!",
          text: e.response.data,
          type:'error'
        });
      })
    },
    addcomment(data){
      // modal
      this.resetComment()
      this.$refs.addCommentModal.show()
      this.comment.name = '#PR'+data.prescriptionID.split('-')[0]
      this.comment.prescriptionID = data.prescriptionID
      this.comment.title = ''
      this.comment.body = ''
      
    },
    editcomment(data){
      // modal
      this.$refs.addCommentModal.show()
      this.comment.editComment = data.title
      this.comment.id = data._id
      this.comment.title = data.title
      this.comment.body = data.body
      
    },
    viewcomment(prescriptionID){
      // modal
      this.$refs.viewCommentModal.show()
      this.comment.prescriptionID = prescriptionID
      this.comment.name = '#PR'+prescriptionID.split('-')[0]

      axios.get('/prescription/comment/'+prescriptionID)
      .then(response=>{
        //
        this.comments = response.data
        
      })
      .catch( e => {
        this.$swal({
          title:"Failed!",
          text: e.response.data,
          type:'error'
        });
      })
    },
    viewmed(data){
      // modal
      this.$refs.viewMedModal.show()
      this.med.name = data.drugname+' ('+data.qty+')'

      const id = data.medID ? data.medID : data._id

      axios.get('/medication/'+id)
      .then(response=>{
        //
        this.meds = response.data
        
      })
      .catch( e => {
        this.$swal({
          title:"Failed!",
          text: e.response.data,
          type:'error'
        });
      })
    },
    checkMed(data){
     // modal
      this.$refs.addDateModal.show()
      this.med.datetime = new Date(data.date).toUTCString().substr(4,12)+', '+this.formatAMPMString((data.date).substr(11, 8))
      this.med.id = data._id
      this.med.status = "Taken"
      this.med.data = data
      
    },
    medDateTime() {

      axios.patch('/medication/status', this.med)
      .then((response)=>{
        //
        this.$swal({
                title:"Good job!",
                text: response.data,
                type:'success'
              });

        //
        this.viewmed(this.med.data)

        this.$refs.addDateModal.hide()

        
      })
      .catch( e => {
        this.$swal({
          title:"Failed!",
          text: e.response.data,
          type:'error'
        });
      })
    },
    checkStatus(data){
      //
      axios.patch('/medication/status', { id : data._id, status: data.due })
      .then((response)=>{
        //
        this.$swal({
                title:"Good job!",
                text: response.data,
                type:'success'
              });

        //
        this.viewmed(data)

        
      })
      .catch( e => {
        this.$swal({
          title:"Failed!",
          text: e.response.data,
          type:'error'
        });
      })
    },
    delcomment(data) {

      this.$swal({
				text:`Are you sure you want to delete '${data.title}'?`,
				showCancelButton: true,
				confirmButtonText: 'Yes',
        type:'error'
			}).then((result)=>{

        if(result.value){

          axios.delete('/prescription/comment/'+this.comment.prescriptionID+'/'+data._id)
            .then(response=>{
              //
              this.$swal({
                title:"Good job!",
                text: `'${data.title}' `+response.data,
                type:'success'
              });
              //
              this.viewcomment(this.comment.prescriptionID)
            })
            .catch( e => {
              this.$swal({
                title:"Failed!",
                text: e.response.data,
                type:'error'
              });
          })
        }
      })
    },
    submitComment(){

      let url
      let method

      if (this.comment.editComment) {
        url = '/prescription/comment/'+this.comment.title
        method = axios.patch;
      } else {
        url = '/prescription/comment'
        method = axios.post;
      }

      method(url, { prescription: { prescriptionID: this.comment.prescriptionID }, title: this.comment.title, body: this.comment.body, id: this.comment.id} )
      .then(response=>{
        //
        this.$swal({
          title:"Good job!",
          text: response.data,
          type:'success'
        });

        //
        this.$refs.addCommentModal.hide()
        
        this.viewcomment(this.comment.prescriptionID)
        //
        
        
      })
      .catch( e => {
        this.$swal({
          title:"Failed!",
          text: e.response.data,
          type:'error'
        });
      })

    },
    formatAMPMString(date) {
      const tdate = date.split(':');
      let hours = tdate[0];
      let minutes = tdate[1];
      let ampm = hours >= 12 ? 'PM' : 'AM';
      hours = hours % 12;
      hours = hours ? hours : 12;
      minutes = minutes.toString().padStart(2, '0');
      let strTime = hours + ':' + minutes + ' ' + ampm;
      return strTime;
    },
    getQty(data){

      if (!data.sdate && !data.edate && !data.dose && !data.dosing){
        return 0;
      }

      const sd = moment(new Date(data.sdate))
      const ed = moment(data.edate)
      
      let times
      let dx = parseInt(data.dosage)
      let interval 

      switch (dx) {
        case 1:

          times = 1
          
          break;

        case 2:

          times = 2
          
          break;
        
        case 3:

          times = 3
          
          break;

        case 4:

          times = 4
          
          break;
          
        case 5:

          times = 1
          
          break;

        case 6:

          times = 1
          
          break;

        case 7:

          times = 1
          
          break;
        
        case 8:

          times = 2
          
          break;

        case 9:

          times = 3
          
          break;

        case 10:

          times = 4
          
          break;
          
        case 11:

          times = 1
          
          break;

        case 12:

          times = 1
          
          break;

        default:
          break;
      }

      if (dx < 7 ) {
        //
        interval = 'days'

      } else if (dx > 6 && dx <= 12) {
        //
        interval = 'weeks'

      }
      

      const dif = (ed.diff(sd, interval))+1

      const tot = data.dose * dif * times

      data.qty = tot

      return tot
    }
  },
  
}
</script>
<style scoped>
/* #patientForm .form-control {
 font-size: inherit;
} */

.table tr > td {
  color: rgba(43,43,43,.54);
}
</style>